import { MailOutlineIcon, PageHeader } from '@billda/design-system';

const SUPPORT_EMAIL = 'support@billda.co.uk';

export function Support() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader title="Support" />
      <div className="flex-1 overflow-auto px-4 py-8 sm:px-6">
        <section className="max-w-2xl">
          <h2 className="type-h4">Contact support</h2>
          <p className="mt-2 max-w-[65ch] type-body-md text-content-secondary">
            Email the support team with the organisation, page, and problem you
            were working on.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="mt-5 inline-flex items-center gap-2 rounded-lg bg-surface-primary px-4 py-2.5 type-body-md font-semibold text-on-primary no-underline outline-none transition-colors hover:bg-surface-primary-hover focus-visible:ring-2 focus-visible:ring-border-focused focus-visible:ring-offset-2 focus-visible:ring-offset-surface-canvas"
          >
            <MailOutlineIcon className="size-4" aria-hidden="true" />
            {SUPPORT_EMAIL}
          </a>
        </section>
      </div>
    </div>
  );
}
